import React from 'react'
import { CircularProgress, Grid } from '@mui/material'

const Loading = () =>
  <Grid container item xs={12} justifyContent={'center'} style={{ marginTop: '30px' }}>
    <CircularProgress size={20} />
  </Grid>

export default Loading
